import './styles/textField.css';
import classNames from 'classnames';

interface TextFieldProps {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
  maxLength?: number;
  alignRight?: boolean;
  email?: boolean;
  fullWidth?: boolean;
  truncate?: boolean;
}

function TextField(props: TextFieldProps) {
  const { value, onChange, placeholder, maxLength, alignRight, email, fullWidth, truncate } = props;

  const textFieldClass = classNames('text-field', {
    'text-field-align-right': alignRight,
    'w-full': fullWidth,
    truncate: truncate,
  });

  return (
    <input
      className={textFieldClass}
      maxLength={maxLength ? maxLength : 10}
      type={email ? 'email' : 'text'}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

export default TextField;
